module.exports = __webpack_public_path__ + "static/media/eliminationIcon.30426d12.png";